import {
    ContentImage,
    ContentText,
} from '@/components/molecules/PremiumOverview'
import bgImg from '/assets/aem-premium-overview-header-bg.png'
import fgImg from '/assets/aem-premium-overview-header-analytics.png'
import { useTranslation } from 'react-i18next'
import { Icon } from '@/components/atoms'
import { FormattedI18nString } from '@/utils/FormattedI18nString'

const listItems = [
    {
        icon: <Icon name="check" />,
        text: (
            <FormattedI18nString i18nKey="active_management.premiumOverview.header.firstListItem" />
        ),
    },
    {
        icon: <Icon name="check" />,
        text: (
            <FormattedI18nString i18nKey="active_management.premiumOverview.header.secondListItem" />
        ),
    },
    {
        icon: <Icon name="check" />,
        text: (
            <FormattedI18nString i18nKey="active_management.premiumOverview.header.thirdListItem" />
        ),
    },
]

export const Header: React.FC = () => {
    const { t } = useTranslation('translations')

    return (
        <div
            className="mt-12 grid grid-cols-1 items-center gap-12 lg:mt-0 lg:grid-cols-2"
            data-testid="premium-overview-header"
        >
            <div className="flex h-full w-full justify-start lg:justify-center">
                <ContentText
                    className="pl-6 lg:ml-auto"
                    title={t('active_management.premiumOverview.header.title')}
                    subtitle={t(
                        'active_management.premiumOverview.header.subtitle'
                    )}
                    list={listItems}
                    footer={
                        <>
                            <span className="text-body-medium">
                                <FormattedI18nString i18nKey="active_management.premiumOverview.header.contact" />
                            </span>
                            <a
                                href="mailto:contact@myenergynetwork.com"
                                className="font-semibold text-blue-500"
                            >
                                {t(
                                    'active_management.premiumOverview.footer.email'
                                )}
                            </a>
                            .
                        </>
                    }
                />
            </div>
            <ContentImage
                bgSrc={bgImg}
                fgSrc={fgImg}
                containerClassName="max-h-[504px]"
                className="h-auto max-h-[313.91px]"
            />
        </div>
    )
}
